module.exports = __webpack_public_path__ + "static/img/report3d_function04.45f01477.png";